import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from './translate.service';
import { BaseService } from '../shared/services/base.service';
import { LoaderService } from './loader.service';
import { SmartModalService } from './smart-modal.service';
import { PopUpOverGridWithControlsComponent } from '../components/dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { editableGridService } from '../components/dynamic-Grid-with-control/editableGrid.service';
import { AlertsService } from './alerts.service';
@Injectable({
  providedIn: 'root'
})
export class CimsService {
  KX_CIMS_MAPPING:boolean=false;
  constructor(
    private baseService: BaseService,
    public loaderService : LoaderService,
    public modalService: SmartModalService,
    public editableGridService  : editableGridService,
    public alert : AlertsService
  ) {

    this.KX_CIMS_MAPPING = this.iskxCimsMapping();
  }
  iskxCimsMapping(): boolean {
    const isCimsConfigActive = sessionStorage.getItem('YeK9fx4DQI') === 'true';
    return !isCimsConfigActive && sessionStorage.getItem('KX_CIMS') === 'yes';
  }
  getCimsName(){
    return "sanjeev";
  } 
  getDrugInteraction(items: any[]): void {
    if (!items || items.length === 0) return;
  
    const filterKey = this.iskxCimsMapping() ? 'drugId' : 'drugName';
    const filterValue = items
    .filter(item => this.iskxCimsMapping() ? item.guid?.trim() : item.displayName?.trim()) // Filter valid items
    .map(item => {
      // Use guid if available, otherwise fallback to displayName
      const valueToEncode = this.iskxCimsMapping() && item.guid?.trim() 
        ? item.guid 
        : item.displayName;
      return btoa(valueToEncode);
    })
    .join('!!!');
  
    const requestObj = { filter: `${filterKey}:${filterValue}` };
  
    this.loaderService.showSpinner();
  
    this.baseService
      .getData(
        requestObj,
        "",
        "stock",
        "inventory-management",
        "GET_DRUG_INTERACTIONS_FROM_INTEGRATION"
      )
      .subscribe({
        next: (res) => {
          this.loaderService.hideSpinner();
  
          if (res?.errCode === 0 && res.resource?.length > 0) {
            const data = res.resource[0];
            if (data?.itemName) {
              this.showCimsResponse(data.itemName, 'Drug to Drug interaction');
            } else {
              console.warn("Item name is missing in the response data.");
              // TODO: Handle case where itemName is missing
            }
          } else {
            console.warn("Invalid response or no resources found.");
          }
        },
        error: (err) => {
          console.error('Error fetching drug interactions:', err);
          this.loaderService.hideSpinner();
        },
      });
  }
  
  
  
  showCimsResponse(res, title) {
    const modalData = {
      type: "htmlViewer",
      html: res,
    };
  
    const modalSize = this.editableGridService.checkingModalSize('md');
  
    this.modalService
      .open(PopUpOverGridWithControlsComponent, modalData, title, modalSize)
      .subscribe({
        next: () => console.log("Modal closed"),
        error: (err) => console.error("Error closing modal:", err),
      });
  }
    getItemName(event){
        if(event && event.data && event.data.displayName){
            return `Monograph not available for ${event.data.displayName}`;
        }
    }
  getMonoGraph(event: any): boolean {
    let args: string | null = null;
  
    if (this.iskxCimsMapping()) {
      const id = event?.data?.guid || '';
      if (!id) {
        this.alert.error(this.getItemName(event));
        return false;
      }
      args = `drugId:${id}`;
    } else {
      const itemName = event?.data?.displayName || '';
      if (!itemName) {
        this.alert.error(this.getItemName(event));
        return false;
      }
      args = `drugName:${itemName}`;
    }
  
    this.loaderService.showSpinner();
  
    this.baseService
      .get("GET_DRUG_MONOGRAPH_FROM_INTEGRATION", args, "stock", "inventory-management")
      .subscribe({
        next: (res) => {
          this.loaderService.hideSpinner();
  
          if (res?.errCode === 0 && res.resource?.length > 0) {
            const data = res.resource[0];
            console.log("Response:", res);
  
            if (data?.itemName) {
              this.showCimsResponse(data.itemName, 'Mono Graph');
            } else {
              console.warn("Item name is missing in the response data.");
              // TODO: Handle case when itemName is missing
            }
          } else {
            console.warn("Invalid response or no resources found.");
          }
        },
        error: (err) => {
          console.error("Error fetching monograph:", err);
          this.loaderService.hideSpinner();
        },
      });
  }
  
}
